import { FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import { outlinedFieldStyles } from "./fieldStyles";


export default function CustomSelect({ values, onChange, error, data, title, required, disabled, label, IconComponent, placeholder, valueName, labelName }) {
    return (
        <>
            <FormControl variant="outlined" fullWidth error={Boolean(error)}>
                {(title || required) && <FormLabel>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>}
                <Select
                    {...(IconComponent ? { IconComponent } : {})}
                    size="small"
                    displayEmpty={Boolean(placeholder)}
                    value={values}
                    required={required}
                    disabled={disabled}
                    sx={outlinedFieldStyles}
                    onChange={(e) => onChange(e)}
                    style={{ color: values === "" && "#c8c8c8" }}>
                    <MenuItem style={{ display: "none" }} key={""} value="" disabled>{placeholder || "Choose"}</MenuItem>
                    {data && data.length > 0 && data.map((option, idx) => {
                        const isObject = option !== null && typeof option === "object";
                        const optionValue = isObject
                            ? (valueName ? option[valueName] : option.value ?? option.id)
                            : option;
                        const optionLabel = isObject
                            ? (labelName ? option[labelName] : option.label ?? option.name ?? optionValue)
                            : option;
                        return <MenuItem key={optionValue ?? idx} value={optionValue} disabled={Boolean(isObject && option.disabled)}>{optionLabel}</MenuItem>;
                    })}
                </Select>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}

        </>


    );
}
